import './main.scss'
import * as Sentry from '@sentry/browser';

import 'bootstrap';

let feedbackForm: { close: any; removeFromDom: any; appendToDom: any; open: any; el?: unknown; } | undefined = undefined;
async function collectFeedback() {
    const feedback = Sentry.getFeedback()
    if(feedback) {
        if(!feedbackForm) {
            const sentryUser = window.FIRST_ENV.userEmail && window.FIRST_ENV.userName ? {
                email: 'email',
                name: 'fullName'
            } : undefined
            feedbackForm = await feedback.createForm({
                formTitle: "Submit Feedback",
                submitButtonLabel: "Submit Feedback",
                useSentryUser: sentryUser,
                showEmail: !sentryUser,
                showName: !sentryUser,
                messagePlaceholder: "Write your feedback here...",
                showBranding: false,
                onFormClose: () => {
                    feedbackForm?.close();
                },
                onFormSubmitted: () => {
                    feedbackForm?.removeFromDom();
                    feedbackForm = undefined;
                }
            })
            feedbackForm.appendToDom();
        }
        feedbackForm.open();
    }
}
document.getElementById('feedbackLink')?.addEventListener('click', (e) => {
    e.preventDefault()
    collectFeedback()
});